import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CalendarFiltersState {
  meetingType: string;
  family: string;
}
const initialState: CalendarFiltersState = {
  meetingType: '',
  family: '',
};  
const calendarFiltersSlice = createSlice({
  name: 'calendarFilters',
  initialState,
  reducers: {
     setMeetingType(state, action: PayloadAction<string>) {
      state.meetingType = action.payload;
    },
    setFamily(state, action: PayloadAction<string>) {
      state.family = action.payload;
    },
  },
});

export const { setMeetingType, setFamily } = calendarFiltersSlice.actions;
export default calendarFiltersSlice.reducer;
